import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteInspectionService } from '../../../api/elite/routes/inspection.service';
import { InspectionApiDto } from '../../../api/elite/dto/inspection.dto';
import { ApiRouteDepartmentService } from '../../../api/elite/routes/department.service';
import { map } from 'rxjs/operators';
import { Shift } from '../../../api/elite/types/shift';

@Injectable({
  providedIn: 'root',
})
export class QualityControlRejectApiService {
  protected readonly apiInspectionRouter = inject(ApiRouteInspectionService);
  protected readonly apiRouteDepartmentService = inject(
    ApiRouteDepartmentService
  );

  constructor() {}

  addRejectionRecord(
    body: InspectionApiDto['reject']['body']
  ): Observable<InspectionApiDto['reject']['result']> {
    return this.apiInspectionRouter.reject(body);
  }

  all(department: string): Observable<Shift[]> {
    return this.apiRouteDepartmentService
      .getDataV2(department, {
        includeShifts: true,
      })
      .pipe(map((result) => result.shifts));
  }
}
